import React, { useState } from 'react'
import './style.css'

const SubMenu = ({ menu }) => {
  const [selected, setSelected] = useState([0, 0])
  const isSelected = (groupIndex, itemIndex) =>
    groupIndex === selected[0] && itemIndex === selected[1]

  return (
    <div className='sub-menu-menu'>
      <div className='sub-menu-groups'>
        {Object.keys(menu).map((groupTitle, groupIndex) => {
          return (
            <div key={`group-${groupIndex}`} className='sub-menu-group'>
              <div className='sub-menu-groupTitle'>{groupTitle}</div>
              <ul className='sub-menu-items'>
                {menu[groupTitle].map((item, itemIndex) => {
                  return (
                    <li
                      key={`tab-${groupIndex}-${itemIndex}`}
                      className={
                        isSelected(groupIndex, itemIndex)
                          ? 'sub-menu-is-selected'
                          : ''
                      }
                      onMouseEnter={(e) => setSelected([groupIndex, itemIndex])}
                    >
                      <a href={item.link}>
                        <span>{item.title}</span>
                      </a>
                    </li>
                  )
                })}
              </ul>
            </div>
          )
        })}
      </div>
      <div className='sub-menu-content'>
        {Object.keys(menu).map((groupTitle, groupIndex) => {
          return menu[groupTitle].map((slide, slideIndex) => {
            return (
              <div
                key={`slide-${groupIndex}-${slideIndex}`}
                className={
                  isSelected(groupIndex, slideIndex)
                    ? 'sub-menu-is-selected sub-menu-slide'
                    : 'sub-menu-slide'
                }
              >
                <p>
                  <img src={slide.image} alt={slide.title} />
                </p>
                <p>
                  <a href={slide.link}>
                    <span>Learn More</span>
                  </a>
                </p>
              </div>
            )
          })
        })}
      </div>
    </div>
  )
}

export default SubMenu
